import React from 'react';
import { SelectMultiple } from 'tea-component';
import { useIntl } from 'umi';

interface DateSelectProps {
  value?: any
  defaultValue?: any
  optionsDate?: Array<any>;
  placeholder?: string;
  className?: string;
  boxClassName?: string;
  searchable?: boolean;
  searchPlaceholder?: string;
  onChange?: (value) => void
}

export default function DateSelect(props: DateSelectProps) {
  const {
    value,
    defaultValue,
    optionsDate,
    placeholder = '请选择推送日期',
    className,
    boxClassName,
    searchable,
    searchPlaceholder = 'Search',
    onChange
  } = props
  const { formatMessage } = useIntl()

  return (
    <SelectMultiple
      value={value}
      defaultValue={defaultValue}
      className={`subscription-setting-date-select ${className ? `${className}` : ''}`}
      boxClassName={`subscription-setting-date-select__dropdown ${boxClassName ? `${boxClassName}` : ''}`}
      options={optionsDate}
      appearance='button'
      placeholder={placeholder}
      staging={false}
      searchable={searchable}
      searchPlaceholder={formatMessage({id: 'selector_multiple_component_placeholder'})}
      matchButtonWidth
      allOption={{
        value: 'all',
        text: formatMessage({id: 'selector_multiple_component_select_all'}),
      }}
      onChange={onChange}
    />
  );
}